import qs from 'qs';
import { useQuery } from 'react-query';

import { axios } from 'lib';

const getConsortiumGroupFilesCount = (dpsID, dcID) => {
  return axios.get(
    `/api/dps/${dpsID}/consortium_groups/${dcID}/files/count`
  );
};

export const useConsortiumGroupFilesCount = (dpsID, dcID, options = {}) => {
  return useQuery(
    `dps-consortium-group-${dcID}-count`,
    () => getConsortiumGroupFilesCount(dpsID, dcID),
    {
      //@ts-ignore
      initialData: { data: { count: 0 } },
      select: ({ data }) => data,
      ...options,
    }
  );
}
